import { render, staticRenderFns } from "./OrganizationSearchDisplay.vue?vue&type=template&id=1252ec2a&scoped=true&"
import script from "./OrganizationSearchDisplay.vue?vue&type=script&setup=true&lang=js&"
export * from "./OrganizationSearchDisplay.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252ec2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemContent,VListItemSubtitle,VListItemTitle})
